import React, {createContext, useState} from 'react';
import { API, defaultError } from "../config";
import axios from "axios";

const MyProcedureClassesContext = createContext();

const MyProcedureClassesProvider = ({ children }) => {
    const [procedureClasses, setProcedureClasses] = useState([]);
    const [error, setError] = useState({"error": false, "message": ""});
    const [loading, setLoading] = useState(false);

    const getProcedureClasses = async (procedureTypeLetter) => {
        setError({"error": false, "message": ""});
        setLoading(true);
        await axios.get(`${API}/classes/classes/${procedureTypeLetter}`).then(res => {
            if(res.data.error){
                setLoading(false);
                setError({"error": true, "message": res.data.response});
                return;
            }
            setError({"error": false, "message": ""});
            setProcedureClasses(res.data.response);
        }).catch(err=>{
            setError(defaultError);
        })
        setLoading(false);
    }

    return (
        <MyProcedureClassesContext.Provider value={{
            procedureClasses,
            getProcedureClasses,
            error,
            setError,
            loading,
            setLoading
        }}>
            {children}
        </MyProcedureClassesContext.Provider>
    );
}

export { MyProcedureClassesProvider }
export default MyProcedureClassesContext;
